import { Message } from '@messageformat/react';
import { ReactElement } from 'react';
import { ReactComponent as Image069 } from '../images/OP_symbolikuvitus_96_069.svg';
import { HeadingType } from '../types';
import FullWidthHighlightSection from './FullWidthHighlightSection';

interface Props {
  questionNumber: number;
  totalQuestions: number;
  headingAs?: HeadingType;
}

const CourseTaskHeader = (props: Props): ReactElement => {
  const { questionNumber, totalQuestions, headingAs: Heading = 'h2' } = props;
  return (
    <FullWidthHighlightSection>
      <Heading
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', flex: 1 }}
      >
        <Message id="course_task" />
        <Image069
          aria-hidden="true"
          style={{
            height: '106px',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
        <div className="investoracademy-task-counter">
          {questionNumber}/{totalQuestions}
        </div>
      </Heading>
    </FullWidthHighlightSection>
  );
};

export default CourseTaskHeader;
